import React, { useState } from "react";
import { withStyles, makeStyles } from "@material-ui/core/styles";
import Button from "@material-ui/core/Button";
import "../../../../src/pages/FormsDatasheets/CoopPreapprovalClaimForms/ApprovalForms/CoOpTabs/RequestRowDetail.scss";
import styles from "layouts/Dashboard/styles";
import "../../../../src/pages/Administration/CoopRequests/AdminRequestDetail.scss";
import PDFimg from "../../../images/pdf-file-format.png";
import excelimg from "../../../images/excel.png";
import { CSVLink } from "react-csv";
import jsPDF from "jspdf";
import html2canvas from "html2canvas";
import { DvrReportPdfDetail } from "./DvrReportPdfDetail";
import compose from "recompose/compose";
import { withRouter } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField";
import { Mutation } from "react-apollo";
import { ADD_DVR_COMMENT } from "../queries";
import { toast } from "react-toastify";
import auth from "Auth";

const useStyles = makeStyles((theme) => ({
  modal: {
    display: "flex",
    alignItems: "flex-start",
    justifyContent: "center",
    maxHeight: "95%",
    overflow: "scroll",
    top: "3.5% !important",
  },
  paper: {
    backgroundColor: theme.palette.background.paper,
    border: "1px solid #707070",
    boxShadow: "0px 3px 6px 0px #00000029",
    padding: theme.spacing(4),
    width: "768px",
    maxWidth: "90%",
  },
  PrimaryButton: {
    backgroundColor: "#456790",
    color: "#fff",
    fontSize: "15px",
    "&:hover": {
      backgroundColor: "#2167BC",
    },
  },
  CustomSuccessButton: {
    backgroundColor: "#3B8010",
    color: "#fff",
    fontSize: "15px",
    "&:hover": {
      backgroundColor: "#5D9930",
    },
    padding: "0.58rem 1rem",
    display: "inline-flex",
    alignItems: "center",
    borderRadius: "3px",
    verticalAlign: "middle",
    textDecoration: "none",
  },
  save_btn:{
    padding: "8px 50px",
    borderRadius: "5px",
    backgroundColor: "#3b6894",
    color: "#fff",
    fontSize: "20px",
    fontWeight: "600",
  },
}));

const DvrReportDetail = ({
  isEdit,
  row,
  type,
  setEdit,
  requirementDataArray,
  history,
}) => {
  const classes = useStyles();
  const [isSubmit, setIsSubmit] = useState(false);
  const [errors, setErrors] = useState(false);
  const [comment, setComment] = useState("");

  const data1 = [
    ["Date", row?.date || "-"],
    ["Dealership", row?.profile?.name || "-"],
    ["Contact Phone", row?.phone || "-"],
    ["Fax Number", row?.fax || "-"],
    ["Address", row?.address || "-"],
    ["Address 2", row?.address_2 || "-"],
    ["BTA", row?.bta || "-"],
    ["Program", row?.program || "-"],
    ["Sales Goal", row?.sales_goal || "-"],
    ["Sales Goal Wholesale in Units", row?.whole_sale_units || "-"],
    ["Sales Goal Wholesale in Dollars", row?.whole_sale_dollars || "-"],
    ["Sales Goal Retail in Units", row?.retail_units || "-"],
    ["Sales Goal Retail in Dollars", row?.retail_dollars || "-"],
    ["Sales Goal In Order in Units", row?.on_order_units || "-"],
    ["Sales Goal In Order in Dollars", row?.on_order_dollars || "-"],
    ["Average Market Share", row?.average_market_share || "-"],
    ["B. T. A Current Market", row?.bta_current_market_share || "-"],
    [
      "Is There a Current Deficiency?",
      row?.current_deficiency === true
        ? "Yes"
        : row?.current_deficiency === false
        ? "No"
        : null,
    ],
    ["#Units to Correct", row?.correct_deficiency || "-"],
    ["Carolina Skiff No of Boats Displayed", row?.carolina_no_of_boats || "-"],
    ["Sea Chaser No of Boats Displayed", row?.sea_chaser_no_of_boats || "-"],
    [
      "Does Dealer have a marketing/advertising Campaign?",
      row?.advertising_campaign === true
        ? "Yes"
        : row?.advertising_campaign === false
        ? "No"
        : null || "-",
    ],
    ["Comments", row?.comments || "-"],
  ];

  const separator = [
    ["", ""],
    ["", ""],
  ];
  const headers1 = [["Other Brand Currently in Stock:"]];
  const headers2 = [["Description", "Qty"]];
  const headers3 = [["Our Brand Currently in Stock:"]];
  let data2 = [];
  let data3 = [];
  if (row && row?.dvr_other_brands?.length > 0) {
    data2 =
      row &&
      row?.dvr_other_brands?.map((item) => [
        `${item?.description || "-"}`,
        `${item?.qty || "-"}`,
      ]);
  }
  if (row && row?.dvr_our_brands?.length > 0) {
    data3 =
      row &&
      row?.dvr_our_brands?.map((item) => [
        `${item?.description || "-"}`,
        `${item?.qty || "-"}`,
      ]);
  }
  let combinedData = [...data1, ...separator];
  if (
    row &&
    row?.dvr_other_brands?.length > 0 &&
    !row?.dvr_our_brands?.length > 0
  ) {
    combinedData = [...data1, ...separator, ...headers1, ...headers2, ...data2];
  } else if (
    row &&
    !row?.dvr_other_brands?.length > 0 &&
    row?.dvr_our_brands?.length > 0
  ) {
    combinedData = [...data1, ...separator, ...headers3, ...headers2, ...data3];
  } else if (
    row &&
    row?.dvr_other_brands?.length > 0 &&
    row?.dvr_our_brands?.length > 0
  ) {
    combinedData = [
      ...data1,
      ...separator,
      ...headers1,
      ...headers2,
      ...data2,
      ...separator,
      ...headers3,
      ...headers2,
      ...data3,
    ];
  } else {
    combinedData = [...data1, ...separator];
  }

  const handleChanges = (event) => {
    const inputText = event.target.value;

    if (inputText.length <= 700) {
      setComment(inputText);
      setErrors(false);
    } else {
      setErrors(true);
    }
  };

  const tableBody = (
    <table cellSpacing="0" className="detailTable">
      <tbody>
        <tr>
          <td>Date:</td>
          <td colSpan={2}>{row?.date || "-"}</td>
        </tr>
        <tr>
          <td>Dealership:</td>
          <td colSpan={2}>{row?.profile?.name || "-"}</td>
        </tr>
        <tr>
          <td>Contact Name:</td>
          <td colSpan={2}>{row?.contact_name || "-"}</td>
        </tr>
        <tr>
          <td>Phone:</td>
          <td colSpan={2}>{row?.phone || "-"}</td>
        </tr>
        <tr>
          <td>Fax:</td>
          <td colSpan={2}>{row?.fax || "-"}</td>
        </tr>
        <tr>
          <td>Address:</td>
          <td colSpan={2}>
            {row?.address || "-"}&nbsp;{row?.address_2}
          </td>
        </tr>
        <tr>
          <td>BTA:</td>
          <td colSpan={2}>{row?.bta || "-"}</td>
        </tr>
        <tr>
          <td>Program:</td>
          <td colSpan={2}>{row?.program || "-"}</td>
        </tr>
        <tr>
          <td>Sales Goal:</td>
          <td colSpan={2}>{row?.sales_goal || "-"}</td>
        </tr>
        <tr>
          <td>Sales Goal Wholesale:</td>
          <td colSpan={2}>
            Units:{row?.whole_sale_units || "-"}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dollars:
            {row?.whole_sale_dollars || "-"}
          </td>
        </tr>
        <tr>
          <td>Sales Goal Retail:</td>
          <td colSpan={2}>
            Units:{row?.retail_units || "-"}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dollars:
            {row?.retail_dollars || "-"}
          </td>
        </tr>
        <tr>
          <td>Sales Goal In Order:</td>
          <td colSpan={2}>
            Units:{row?.on_order_units || "-"}
            &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;Dollars:
            {row?.on_order_dollars || "-"}
          </td>
        </tr>
        <tr>
          <td>Average Market Share:</td>
          <td colSpan={2}>{row?.average_market_share || "-"}</td>
        </tr>
        <tr>
          <td>B. T. A Current Market:</td>
          <td colSpan={2}>{row?.bta_current_market_share || "-"}</td>
        </tr>
        <tr>
          <td>Is There a Current Deficiency?:</td>
          <td colSpan={2}>
            {row?.current_deficiency === true
              ? "Yes"
              : row?.current_deficiency === false
              ? "No"
              : null}
          </td>
        </tr>
        <tr>
          <td>#Units to Correct:</td>
          <td colSpan={2}>{row?.correct_deficiency || "-"}</td>
        </tr>
        <tr>
          <td>#Boats Displayed:</td>
          <td>Carolina Skiff: {row?.carolina_no_of_boats || "-"}</td>
          <td>Sea Chaser: {row?.sea_chaser_no_of_boats || "-"}</td>
        </tr>
        <tr>
          <td>Does Dealer have a marketing/advertising Campaign?:</td>
          <td colSpan={2}>
            {row?.advertising_campaign === true
              ? "Yes"
              : row?.advertising_campaign === false
              ? "No"
              : null}
          </td>
        </tr>
        <tr>
          <td style={{ verticalAlign: "top" }}>
            Other Brand Currently in Stock:
          </td>
          <td colSpan={2}>
            <table cellSpacing="0" className="" width="100%">
              <tbody>
                {row?.dvr_other_brands?.map((res) => {
                  return (
                    <>
                      <tr>
                        <td>Description: {res?.description || "-"}</td>
                        <td>Qty: {res?.qty || "-"}</td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ verticalAlign: "top" }}>
            Our Brand Currently in Stock:
          </td>
          <td colSpan={2}>
            <table cellSpacing="0" className="" width="100%">
              <tbody>
                {row?.dvr_our_brands?.map((res) => {
                  return (
                    <>
                      <tr>
                        <td>Description: {res?.description || "-"}</td>
                        <td>Qty: {res?.qty || "-"}</td>
                      </tr>
                    </>
                  );
                })}
              </tbody>
            </table>
          </td>
        </tr>
        <tr>
          <td style={{ verticalAlign: "top" }}>Comments:</td>
          <td colSpan={2}>
            <table cellSpacing="0" cellPadding="6px" className="" width="100%">
                <tbody>
                  {row?.dvr_comments?.map((res) => {
                    return (
                      <tr>
                        <td>
                          {res?.profile?.name || ""}
                        </td>
                        <td>
                          {res?.comment || "-"}
                        </td>
                      </tr>
                    );
                  })}
                </tbody>
            </table>
          </td>
        </tr>
          
      </tbody>
    </table>
  );

  const generatePdf = () => {
    const input = document.getElementById("pdf-content");
    html2canvas(input, { scale: 1 })
      .then((canvas) => {
        const imgData = canvas.toDataURL("image/png");
        const pdf = new jsPDF("p", "pt", "a4");
        pdf.addImage(imgData, "PNG", 0, 0);
        pdf.save(`dvr_report.pdf`);
      })
      .catch((err) => {
        console.error("Error generating PDF: ", err);
      });
  };

  const addComments = (add) => {
    if (!errors) {
      if (comment) {
        setIsSubmit(true);
        add({
          variables: {
            objects: {
              comment: comment,
              profile_id: auth.getSub(),
              dvr_id: row?.id,
            },
          },
        });
      }
    }
  };

  return (
    <div className="request-detail-pg admin-side">
      {type === "dealer" && (
        <>
          {isEdit && (
            <Button
              color="primary"
              variant="contained"
              className={classes.PrimaryButton}
              type="submit"
              onClick={() => history.push(`/dealer-dvr-report/edit/${row?.id}`)}
              style={{ margin: "2em 1em 2em 0em" }}
            >
              Edit
            </Button>
          )}
          <Button
            className={`${classes.PrimaryButton} MuiButtonBase-root MuiButton-root MuiButton-containedSecondary MuiButton-contained`}
            onClick={generatePdf}
            style={{ marginRight: "15px" }}
          >
            <>
              <img
                src={PDFimg}
                alt="PDF"
                width="18px"
                style={{ marginRight: "8px" }}
              />
              Print To Pdf
            </>
          </Button>
          <div id="pdf-content" className="offscreen">
            <DvrReportPdfDetail
              data={row}
              requirementData={requirementDataArray}
            />
          </div>
          <CSVLink
            data={combinedData}
            filename={"dvr_report" + row?.dealer_name + ".csv"}
            className={classes.CustomSuccessButton}
          >
            <img
              src={excelimg}
              alt="PDF"
              width="20px"
              style={{ marginRight: "8px" }}
            />
            Export to EXCEL
          </CSVLink>
        </>
      )}
      <table cellSpacing="0" className="request-detail-table" width="100%">
        {tableBody}
      </table>
      {auth.getRole() === "admin" ? (
        <Grid container>
          <Grid item xs={12} sm={12} md={12} style={{margin: "0px 20px"}}>
            <TextField
              id="comments"
              name="comments"
              label="Add Comment Here"
              multiline
              rows="4"
              variant="outlined"
              onChange={handleChanges}
              margin="normal"
              value={comment || ""}
              error={errors}
              helperText={errors ? "Maximum 700 words allowed" : ""}
              style={{
                width: "100%",
                marginTop: "0px",
              }}
            />
            <div className="button_wrap text-right" style={{textAlign: "right"}}>
              <Mutation
                mutation={ADD_DVR_COMMENT}
                onCompleted={() => setIsSubmit(false)}
              >
                {(addComment, { data, loading, called, error }) => {
                  if (error) toast.error(error?.graphQLErrors?.[0]?.message);
                  return (
                    <Button
                      type="button"
                      color="primary"
                      className="save_btn"
                      disabled={isSubmit}
                      onClick={() => addComments(addComment)}
                      style={{ padding: "8px 30px", borderRadius: "5px",backgroundColor: "#3b6894",color: "#fff",fontSize: "15px",fontWeight: "600",marginLeft: "auto",}}
                    >
                      Save
                    </Button>
                  );
                }}
              </Mutation>
            </div>
          </Grid>
        </Grid>
      ) : null}
    </div>
  );
};
export default compose(withRouter, withStyles(styles))(DvrReportDetail);
